module.exports = __webpack_public_path__ + "img/footer-xl.53edd5a8.png";